import React from "react";
import Nav from "./Navbar";
import Footer from "./Footer";
function FAQ() {
  return (
    <div>
      <Nav />
      <section className="text-gray-700">
        <div className="container px-5 py-24 mx-auto">
          <div className="text-center mb-20">
            <h1 className="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">
              Frequently Asked Question
            </h1>
            <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
              The most common questions about how our business works and what
              can do for you.
            </p>
          </div>
          <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
            <div className="w-full lg:w-1/2 px-4 py-2">
              <details className="mb-4">
                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Name of the primary financial regulatory/supervisors of the bank?
                </summary>

                <span>
                  National Bank of Ethiopia (NBE) & Ethiopian Financial Intelligence Service (EFIS).
                </span>
              </details>
              <details className="mb-4">
                <summary className="font-semibold bg-gray-200 rounded-md py-2 px-4">
                  Dose CBE have policies, procedures and processes to comply and have controls in place to ensure compliance with International and local regulations? If yes, specify the regulations.
                </summary>

                <span>
                  Yes,

                  -FATF Recommendations

                  -Prevention and Suppression of Money Laundering and Financing of Terrorism [Proclamation   No.780/2013]

                  -Financial AML & CFT Compliance Directives No.01/2014.

                </span>
              </details>
              <details className="mb-4">
                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Dose the CBE policy and procedure updated?  If yes, how frequently?

                </summary>

                <span>
                Yes, We revise both CBE's policy and procedure every 5 years or lessor when there is trigger events.
                </span>
              </details>
            </div>
            <div className="w-full lg:w-1/2 px-4 py-2">

              <details className="mb-4">
                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Dose CBE have a sanction policy approved by the management? If yes, what method used by CBE for sanctions screening and what is the name of system implemented?
                </summary>

                <span className="px-4 py-2">
                  Yes, the method used by CBE is automated and the system implemented is SWIFT and FCM.

                </span>
              </details>
              <details className="mb-4">
                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Does CBE provide mandatory AML/KYC training for employees? If Yes, how frequently is training delivered?
                </summary>

                <span className="px-4 py-2">
                Yes, Every Quarter.
                </span>
              </details>
              <details className="mb-4">
                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Is KYC renewed at defined frequencies based on risk rating (periodic review)? If yes, how frequently?
                </summary>

                <span className="px-4 py-2">
                  Yes, -for high risk customers KYC renewal every 3 years.
                  - for medium risk customers KYC renewal every 5 years.
                  - for low risk customers KYC renewal every 7 years.

                </span>
              </details>
			   <details className="mb-4">
                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Could you please explain how do you screen manual for adverse media/negative news?
                </summary>

                <span className="px-4 py-2">
                  We do adverse media screening manually both at the time of on-boarding by every branch units and also centrally and also during review to publicly available news articles, reports, and media to uncover negative information about a person or organization.

                </span>
              </details>
			  
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default FAQ;
